/*
 * Copyright (c) 2020 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import * as _ from 'underscore';
import { NavigatorList } from './navigator-list';

export class DatabaseList extends NavigatorList {
  displayName: string;
  isPinned: boolean;
  isCustom: boolean;
  sortByPriority: boolean;
  autoLaunchViewer: boolean;
  worklistId: string;
  artificiallyAddedWorkItemPosition = {
    index: undefined,
    workItemId: undefined
  };
  linkedWorklists = {} as any;
  protocolWorklist;
  layoutId;
  isLinked;
  parentId;
  createdOn;
  updatedOn;
  filterJson;
  isGlobal;

  [key: string]: any;

  constructor(
    id: string,
    displayName: string,
    isPinned: boolean,
    protocolWorklist: boolean,
    sortByPriority: boolean,
    isLinked: boolean,
    parentId,
    createdOn,
    updatedOn,
    filterJson,
    layoutId,
    isCustom,
    isGlobal: boolean
  ) {
    super('database-list', {
      isFilterable: true,
      isSortable: true
    });

    if (arguments.length && !_.isString(displayName) && !_.isEmpty(displayName)) {
      throw new Error('displayName is required');
    }

    this.worklistId = id;
    this.id = id;
    this.displayName = displayName;
    this.isPinned = isPinned;
    this.isCustom = isCustom;
    this.layoutId = layoutId;
    this.protocolWorklist = protocolWorklist;
    this.sortByPriority = sortByPriority;
    this.isLinked = isLinked;
    this.parentId = parentId;
    this.createdOn = createdOn;
    this.updatedOn = updatedOn;
    this.filterJson = filterJson;
    this.isGlobal = isGlobal;

    //delete this.isFilterable;
    //delete this.isSortable;
  }
}
